export enum SurveyBillingMode {
  Invitations = 0,
  Completed = 1,
}
